import {
  NewsAdminState,
  NewsEarningsActionTypes,
  CREATE_NEWS_FAILURE,
  CREATE_NEWS_INPROGRESS,
  CREATE_NEWS_SUCCESS,
  REMOVE_NEWS_INPROGRESS,
  REMOVE_NEWS_SUCCESS,
  REMOVE_NEWS_FAILURE,
  PUBLISH_NEWS_INPROGRESS,
  PUBLISH_NEWS_SUCCESS,
  PUBLISH_NEWS_FAILURE
} from './types';
import * as Bixby from '$/core';

const initialState: NewsAdminState = {
  isLoading: false,
};

const newsEarningsReducer = (state = initialState, action: NewsEarningsActionTypes): NewsAdminState => {
  switch (action.type) {
    case CREATE_NEWS_INPROGRESS:
    case REMOVE_NEWS_INPROGRESS:
    case PUBLISH_NEWS_INPROGRESS:

      return {
        ...state,
        isLoading: true,
      };

    case CREATE_NEWS_SUCCESS:
    case REMOVE_NEWS_SUCCESS:
    case PUBLISH_NEWS_SUCCESS:

      return {
        ...state,
        isLoading: false,
      };

    case CREATE_NEWS_FAILURE:
    case REMOVE_NEWS_FAILURE:
    case PUBLISH_NEWS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload as Bixby.Models.BixbyError,
      };    
      
    default:
      return state;
  }
};

export default newsEarningsReducer;
